import { createAction } from '@reduxjs/toolkit';
import { stateName } from './constants';
export const updateFeedbackDenyOptionsRequest = createAction("".concat(stateName, "/updateFeedbackDenyOptionsRequest"));
export const confirmComplaintRequest = createAction("".concat(stateName, "/confirmComplaintRequest"));
export const confirmComplaintFailure = createAction("".concat(stateName, "/confirmComplaintFailure"));
export const submitFeedbackRatingRequest = createAction("".concat(stateName, "/submitFeedbackRatingRequest"));
export const submitFeedbackRatingFailure = createAction("".concat(stateName, "/submitFeedbackRatingFailure"));